import { createSlice, current } from "@reduxjs/toolkit";
import countries from "../../lib/countries.json";
import { api } from "../../api/httpclient";
import { addNotification } from "./notificationsslice";
import {
  notificationDurationMiddle,
  transformReportsMenu,
} from "../../lib/utils";
import { setCurrentUser } from "./currentuserslice";
import { setCurrentTheme } from "./currentthemeslice";
import { setAppearance } from "./appearanceslice";
import { setCounter } from "./notificationscounterslice";
import { setSignalRLinkedCompleted } from "./appinitslice";
import { themes } from "../../sass/themes";

const defaultFormInitialValues = {
  name: "",
  company: "",
  businessType: "",
  username: "",
  email: "",
  countryCode: countries.find((c) => c.dial_code === "+961"),
  mobile: "",
};

const initialState = {
  pageLoaded: false,
  pageDisposed: true,
  processing: false,
  processingText: "",
  formKey: new Date().toString(),
  formInitialValues: { ...defaultFormInitialValues },
  formValues: { ...defaultFormInitialValues },
  formServerErrors: [],
  plan: "",
  step: 0,
  subscriptions: [],
  pendingUser: { Email: " ", Username: " " },
  subscriptionId: 0,
  navigateToHome: false,
};

const onBoardingSlice = createSlice({
  name: "onBoardingPage",
  initialState: initialState,
  reducers: {
    setInitialState: (state, action) => ({ ...initialState }),

    setProcessing: (state, action) => {
      const { processing = true, processingText = "" } = action.payload;

      return {
        ...state,
        processing: processing,
        processingText: processing == false ? "" : processingText,
      };
    },

    setPageValue: (state, action) => ({
      ...state,
      [action.payload.id]: action.payload.value,
    }),

    setPendingSubscriptionId: (state, action) => ({
      ...state,
      subscriptionId: action.payload,
    }),

    setFormValue: (state, action) => {
      let id = action.payload.id;
      let value = action.payload.value;

      return {
        ...state,
        formValues: { ...state.formValues, [id]: value },
      };
    },

    setFormServerErrors: (state, action) => ({
      ...state,
      formServerErrors: [...action.payload],
    }),

    navigateToHome: (state, action) => ({
      ...state,
      navigateToHome: action.payload,
    }),

    pageLoaded: (state, action) => {
      const pageState = current(state);
      if (pageState.pageDisposed) return state;

      return {
        ...state,
        pageLoaded: true,
        processing: false,
        processingText: "",
        formKey: new Date().toString(),
        formValues: { ...defaultFormInitialValues },
        formInitialValues: { ...defaultFormInitialValues },
        formServerErrors: [],
        subscriptions: action.payload,
      };
    },

    setCreatePendingSubscription: (state, action) => {
      // window.location.href=data.PaymentLink;
      window.open(action.payload, "_blank");

      return {
        ...state,
        pageLoaded: true,
        processing: false,
        processingText: "",
      };
    },
    setUserPendingSubscription: (state, action) => {
      return {
        ...state,
        pageLoaded: true,
        processing: false,
        processingText: "",
        pendingUser: {
          Username: action.payload.Username,
          Password: action.payload.Password,
          Email: action.payload.Email,
          CompanyName: action.payload.CompanyName,
          BusinessType: action.payload.BusinessType,
          PhoneNumber: action.payload.PhoneNumber,
          Id: action.payload.Id,
          PlanId: action.payload.PlanId,
          UserId: action.payload.UserId,
          TenantId: action.payload.TenantId,
        },
      };
    },

    disposePage: (state, action) => {
      //payload: bool
      if (action.payload) return { ...initialState };
      else return { ...state, pageDisposed: false };
    },
  },
});

export const {
  setPageValue,
  setFormServerErrors,
  setFormValue,
  setInitialState,
  setProcessing,
  pageLoaded,
  setPendingSubscriptionId,
  setCreatePendingSubscription,
  setUserPendingSubscription,
  navigateToHome,
  disposePage,
} = onBoardingSlice.actions;

export default onBoardingSlice.reducer;

export const loadPage = (t) => async (dispatch, getState) => {
  //start with initial values
  dispatch(setInitialState());

  //undispose page
  dispatch(disposePage(false));

  //show loader
  dispatch(
    setProcessing({ processing: true, processingText: t("slices.loadingPage")})
  );

  try {
    var response = await api({
      url: "subscription/getcurrentsubscriptionsinfo",
      method: "post",
      data: {},
    });
    //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
    if (getState().onBoardingPage.pageDisposed) return;
    //it's ok to dispatch here
    let data = response.data.Data;
    dispatch(pageLoaded(data.Subscriptions));
    return Promise.resolve(response);
  } catch (err) {
    //i am here => could be any error included 200 and Succeeded=false
    return Promise.reject(err);
  }
};

export const createPendingSubscription =
  (name, companyName, businessType, username, email, phoneNumber, planId, t) =>
  async (dispatch, getState) => {
    //undispose page
    dispatch(disposePage(false));

    //show loader
    dispatch(
      setProcessing({ processing: true, processingText: t("slices.loadingPage")})
    );

    try {
      var response = await api({
        url: "subscription/creatependingsubscription",
        method: "post",
        data: {
          Name: name,
          CompanyName: companyName,
          BusinessType: businessType,
          Username: username,
          Email: email,
          PhoneNumber: phoneNumber,
          PlanId: planId,
        },
      });

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      if (getState().onBoardingPage.pageDisposed) return;

      //it's ok to dispatch here
      let data = response.data.Data;

      dispatch(setCreatePendingSubscription(data.PaymentLink));

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      return Promise.reject(err);
    }
  };

export const getPendingSubscriptionById =
  (id, t) => async (dispatch, getState) => {
    //undispose page
    dispatch(disposePage(false));

    //show loader
    dispatch(
      setProcessing({ processing: true, processingText: t("slices.loadingPage") })
    );

    console.log("PendingSubscriptionById", id);
    try {
      var response = await api({
        url: "subscription/getpendingsubscriptionbyid",
        method: "post",
        data: {
          Id: id,
        },
      });
      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      if (getState().onBoardingPage.pageDisposed) return;

      //it's ok to dispatch here
      let data = response.data.Data;
      console.log("data getPendingSubscriptionById", data);

      dispatch(setUserPendingSubscription(data));

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      return Promise.reject(err);
    }
  };

export const checkPendingSubscriptionStatus =
  (response, t) => async (dispatch, getState) => {
    let exist = true;
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    let retryCounter = 0;

    dispatch(disposePage(false));

    dispatch(
      setProcessing({ processing: true, processingText: t("slices.loadingPage") })
    );

    console.log("checkPendingSubscriptionStatus", response.data.Data.Id);

    while (exist) {
      await delay(5000);
      retryCounter++;

      if (retryCounter > 10) {
        dispatch(
          addNotification({
            text: t("slices.errorOccurred"),
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
        return;
      }

      try {
        const res = await api({
          url: "subscription/checkpendingsubscriptionstatusbyid",
          method: "post",
          data: {
            Id: response.data.Data.Id,
          },
        });

        if (getState().onBoardingPage.pageDisposed) return;

        exist = res.data.Data.Exist;
        console.log("sub exist", exist);

        if (!exist) {
          try {
            var loginRes = await api({
              url: "auth/login",
              method: "post",
              data: {
                username: response.data.Data.Username,
                password: response.data.Data.Password,
                faceId: null,
                facePin: null,
              },
              //headers:{'h':'1'}
            });

            // Guard loginRes
            if (!loginRes || !loginRes.data) {
              console.warn("Login failed or was cancelled (pageDisposed?)");
              dispatch(setProcessing({ processing: false }));
              return;
            }

            const _response = loginRes.data;
            dispatch(setProcessing({ processing: false }));

            setTimeout(() => {
              dispatch(
                setCurrentUser({
                  ..._response.Data,
                  ReportsMenu: transformReportsMenu(_response.Data.ReportsMenu),
                })
              );

              dispatch(
                setCurrentTheme(themes[_response.Data.ThemeId.toString()])
              );

              dispatch(
                setAppearance({ isRightToLeft: _response.Data.IsRightToLeft })
              );

              dispatch(setCounter(_response.Data.UnreadNotificationsCount));

              const userId = _response.Data.Id;
              const tenantId = _response.Data.Subscription.Id;

              api({
                url: "signalr/connectsignalr",
                method: "post",
                data: { userId, tenantId },
              })
                .then(() => {
                  dispatch(setSignalRLinkedCompleted(true));
                  dispatch(navigateToHome(true));
                })
                .catch(() => dispatch(setSignalRLinkedCompleted(true)));
            }, 750);
            return Promise.resolve(response);
          } catch (err) {
            return Promise.reject(err);
          }
        }
      } catch (err) {
        return Promise.reject(err);
      }
    }
  };
